import { IconType } from "react-icons";
import { MdEmojiTransportation, MdFamilyRestroom, MdLocalMall, MdOutlineAccountBalance, MdOutlineBusinessCenter, MdOutlineCategory, MdOutlineRestaurant, MdOutlineRoomService, MdOutlineSecurity, MdOutlineSpa, MdOutlineWifi, MdPets, MdRecycling, MdRoomService, MdSmokingRooms, MdWash, MdWheelchairPickup } from "react-icons/md";

export type CategorizedFacility = {
  category: string;
  items: string[];
};



const CATEGORY_ICONS: Record<string, IconType> = {
  Accessibility: MdWheelchairPickup,
  "Banking & Payments": MdOutlineAccountBalance,
  "Business & Events": MdOutlineBusinessCenter,
  Dining: MdOutlineRestaurant,
  "Family & Kids": MdFamilyRestroom,
  "Front Desk": MdRoomService,
  Housekeeping: MdWash,
  "In-Room Services": MdOutlineRoomService,
  "Internet Access": MdOutlineWifi,
  Pets: MdPets,
  "Safety & Security": MdOutlineSecurity,
  "Shopping Centres": MdLocalMall,
  "Smoking Policy": MdSmokingRooms,
  "Transport & Parking": MdEmojiTransportation,
  "Travel Sustainable": MdRecycling,
  "Wellness & Recreation": MdOutlineSpa,
};



const getCategoryIcon = (category: string)=>{
    return CATEGORY_ICONS[category] ?? MdOutlineCategory
}



const POPULAR_FACILITIES = [
  "Free WiFi",
  "Non-smoking rooms / property",
  "Parking (general/on-site)",
  "Free parking",
  "Dry cleaning / laundry service",
  "24-hour front desk",
  "Heating",
  "Garden",
  "Tour desk / tours & ticket assistance",
  "Family rooms",
  "Air conditioning",
  "Terrace / sun terrace",
  "TV in room",
  "Luggage storage",
  "Private parking",
  "Bar / lounge",
  "Express check-in/check-out",
  "Fire safety equipment",
  "Daily housekeeping",
  "Outdoor furniture / picnic area",
  "Elevator / lift",
  "Breakfast (free/included)",
  "Safety deposit box",
  "Swimming pool (outdoor)",
  "Airport shuttle",
  "Concierge service",
  "Restaurant",
  "First aid kit",
  "Swimming pool (general)",
  "Key card / key access",
  "Wheelchair accessibility",
  "Meeting / conference facilities",
  "Room service",
  "Shuttle service",
  "Games room / arcade",
  "24-hour security",
  "BBQ facilities",
  "Currency exchange",
  "Ironing service",
  "Spa / wellness centre",
  "Pet-friendly",
  "Water sports",
  "Bicycle rental",
  "Hiking",
  "Coffee shop / coffee house",
  "Fitness centre / gym",
  "Wine / champagne service",
  "Playground",
  "Beach access",
  "Fax / photocopying",
  "Cycling / mountain biking",
  "Car hire",
  "Soundproof rooms",
  "Special diet menus",
  "Multilingual staff",
  "Kitchen / kitchenette",
  "Massage services",
  "Solarium",
  "Babysitting / childcare",
  "Live entertainment",
  "Breakfast (paid/available)",
  "Golf course access",
  "Tennis court",
  "Kids' meals",
  "Skiing / winter sports",
  "Hot tub / jacuzzi",
  "Packed lunches",
  "Fruit / welcome amenities",
  "Sauna",
  "Lockers",
  "Horse riding",
  "Trouser press",
  "Gift shop / newsstand",
  "Swimming pool (indoor)",
  "Beauty / hair / spa treatments",
  "Casino",
  "Allergy-free room",
  "Library",
  "Wedding services",
  "Art / cultural exhibits",
  "Vending machine",
  "Children's pool",
  "ATM / cash machine",
  "Children's TV / entertainment",
  "Valet parking",
  "Steam room / bath",
  "Public transport tickets",
  "Kids' club",
  "LED light bulbs",
  "Outdoor entertainment area",
  "Volleyball / basketball / team sports",
  "Electric vehicle charging",
  "Couples/private dining",
  "Energy-saving switches",
  "Garage",
  "Cooking class",
  "Bathroom",
  "TV",
  "Direct dial telephone",
  "Carport",
  "Eco-friendly toiletries",
  "Fully fenced",
  "Ballroom",
  "Safe",
  "Café",
  "Private picnics",
  "Breakfast",
  "Foot bath",
  "Balcony",
  "Medical service",
  "Limo / town car service",
  "Bulk dispenser for toiletries",
  "Walkway to water",
  "Cloakroom",
  "VIP room facilities",
  "Books",
  "Radio",
  "Organic food",
  "Firewood (free)",
  "Vineyard",
  "Newspapers",
  "Desk",
  "Fan",
  "Dock",
  "Park",
  "Gated community",
  "Snow sports gear",
  "Premium bedding / mattress",
  "Spa",
  "Transfer service",
  "Writing Desk",
  "Electric kettle",
  "Local and international calls",
  "Vacation resort",
  "Pool",
  "Clubhouse",
  "Wheel Chair Access",
  "Towels and bed linen",
  "City View",
  "Oven",
  "Bicycle cleaning area",
  "Snacks",
  "Bicycle repair station",
  "Breakfast served to the table",
  "Projector",
  "Litter box",
  "Alarm clock",
  "Toaster",
  "Make-up mirror",
  "Telescope",
  "Separate bedroom",
  "Hospital bed available",
  "Express Check In / Check Out",
  "Bottled Water",
  "Free Newspaper",
  "Early departure",
  "Climate Control",
  "Reception Area",
  "Theatre / auditorium",
  "Fire Place",
  "Free local calls",
  "Extra Bed/Sofa Bed",
  "Tea service",
  "Sportsbook",
  "Cafe",
  "Sofa Bed",
  "24 Hour Check-In",
];

export { getCategoryIcon, CATEGORY_ICONS, POPULAR_FACILITIES };
